import React, { useState } from "react";
import Logo from "../assets/images/Logo.svg";
import {
  AppBar,
  Toolbar,
  Box,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Menu as MenuIcon, Close as CloseIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const Navbar: React.FC = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navLinks = [
    { label: "Home", path: "/" },
    { label: "Services", path: "/services" },
    { label: "Become a Sitter", path: "/become-a-sitter" },
    { label: "Discover Pet Sitter", path: "/discover-pet-sitter" },
  ];

  const handleNavigation = (path: string) => {
    navigate(path);
    setMobileMenuOpen(false);
  };

  return (
    <AppBar
      position="sticky"
      elevation={1}
      sx={{
        backgroundColor: "#FFFFFF",
      }}
    >
      <Toolbar sx={{ justifyContent: "space-between", py: 1 }}>
        {/* Logo */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            cursor: "pointer",
          }}
          onClick={() => handleNavigation("/")}
        >
          <img
            src={Logo}
            alt="HappyPaws Logo"
            style={{ width: "205px", height: "45px" }}
          />
        </Box>

        {/* Desktop Navigation */}
        {!isMobile ? (
          <>
            <Box sx={{ display: "flex", gap: 3 }}>
              {navLinks.map((link) => (
                <Button
                  key={link.path}
                  onClick={() => handleNavigation(link.path)}
                  sx={{
                    color: "#178B8E",
                    fontSize: "1rem",
                    fontWeight: 500,
                  }}
                >
                  {link.label}
                </Button>
              ))}
            </Box>

            <Box sx={{ display: "flex", gap: 2 }}>
              <Button
                onClick={() => handleNavigation("/login")}
                sx={{ color: "#178B8E" }}
              >
                Log In
              </Button>
              <Button
                variant="contained"
                onClick={() => handleNavigation("/register")}
                sx={{
                  backgroundColor: "#178B8E",
                  "&:hover": {
                    backgroundColor: "#0F6164",
                  },
                }}
              >
                Sign Up
              </Button>
            </Box>
          </>
        ) : (
          /* Mobile Menu Icon */
          <IconButton
            sx={{ color: "#178B8E" }}
            onClick={() => setMobileMenuOpen(true)}
          >
            <MenuIcon />
          </IconButton>
        )}

        {/* Mobile Drawer */}
        <Drawer
          anchor="right"
          open={mobileMenuOpen}
          onClose={() => setMobileMenuOpen(false)}
        >
          <Box sx={{ width: 250, pt: 2 }}>
            <Box sx={{ display: "flex", justifyContent: "flex-end", px: 2 }}>
              <IconButton onClick={() => setMobileMenuOpen(false)}>
                <CloseIcon />
              </IconButton>
            </Box>
            <List>
              {navLinks.map((link) => (
                <ListItem key={link.path} disablePadding>
                  <ListItemButton onClick={() => handleNavigation(link.path)}>
                    <ListItemText
                      primary={link.label}
                      sx={{ color: "#178B8E" }}
                    />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
            <Box
              sx={{
                px: 2,
                pt: 2,
                display: "flex",
                flexDirection: "column",
                gap: 2,
              }}
            >
              <Button
                variant="outlined"
                onClick={() => handleNavigation("/login")}
                fullWidth
              >
                Log In
              </Button>
              <Button
                variant="contained"
                onClick={() => handleNavigation("/register")}
                fullWidth
              >
                Sign Up
              </Button>
            </Box>
          </Box>
        </Drawer>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
